export default "__VITE_ASSET__aeefc297__"